module.exports = __webpack_public_path__ + "img/sn.01ca39ad.svg";